import GeoPoint from '../../type/GeoPoint';

interface Mapped {
  geoPoint: GeoPoint,
}

const isMapped = <T extends {geoPoint: GeoPoint | null}>(item: T): item is (T & Mapped) => !!item.geoPoint;

export default isMapped;
